import { api } from "../../config/axios/interceptor";

export async function getAllInvoice(
  searchKey,
  status,
  startDate,
  endDate,
  page,
  pageSize,
  selectedType
) {
  try {
    let query = `invoice?search=${
      searchKey || ""
    }&page=${page}&pageSize=${pageSize}&type=${selectedType}`;

    if (selectedType === "Patient Info") {
      query += `&status=${status || ""}&startDate=${startDate || ""}&endDate=${
        endDate || ""
      }`;
    }
    const response = await api.get(query);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllMedBill(
  searchKey,
  status,
  startDate,
  endDate,
  page,
  pageSize,
  selectedType
) {
  try {
    let query = `medbill?search=${
      searchKey || ""
    }&page=${page}&pageSize=${pageSize}&type=${selectedType}`;

    if (selectedType === "Patient Info") {
      query += `&status=${status || ""}&startDate=${startDate || ""}&endDate=${
        endDate || ""
      }`;
    }
    const response = await api.get(query);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllTransactionHistory(
  searchKey,
  startDate,
  endDate,
  page,
  pageSize,
  selectedType
) {
  try {
    let query = `invoice/paymentHistory/?search=${
      searchKey || ""
    }&page=${page}&pageSize=${pageSize}&type=${selectedType}`;

    if (selectedType === "Patient Info") {
      query += `&startDate=${startDate || ""}&endDate=${endDate || ""}`;
    }
    const response = await api.get(query);
    return response;
  } catch (error) {
    throw error;
  }
}
// Stat-card summary for the Transaction History page: old (treatment-invoice)
// vs new (medicine-bill) payment counts + collected totals for a date range.
export async function getTransactionHistoryStats(startDate, endDate) {
  try {
    const response = await api.get(
      `invoice/paymentHistory/stats?startDate=${startDate || ""}&endDate=${
        endDate || ""
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getTransactionHistory(
  searchKey,
  status,
  startDate,
  endDate,
  patient_id
) {
  try {
    const response = await api.get(
      // search=${searchKey || ""}&
      `invoice?status=${status || ""}&startDate=${startDate || ""}&endDate=${
        endDate || ""
      }&patient_id=${patient_id || ""}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getSingleInvoice(id) {
  try {
    const response = await api.get(`invoice/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getSingleMedBill(id) {
  try {
    const response = await api.get(`medbill/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addInvoice(payload) {
  try {
    const response = await api.post(`invoice`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function addMedBill(payload) {
  try {
    const response = await api.post(`medbill`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateMedBill(payload, id) {
  try {
    const response = await api.put(`medbill/` + id, payload);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPendingInvoices(id) {
  try {
    const response = await api.get(`invoice/pending/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getPendingMedInvoices(id) {
  try {
    const response = await api.get(`medbill/pending/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function fetchPendingInvoiceTreatments(id) {
  try {
    const response = await api.get(
      `treatment/getPendingInvoiceTreatments?patient_id=${id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getPaymentTransactionHistory(id) {
  try {
    const response = await api.get(`invoice/PaymentIns/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getMedPaymentTransactionHistory(id) {
  try {
    const response = await api.get(`medbill/PaymentIns/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateInvoice(payload, id) {
  try {
    const response = await api.put(`invoice/` + id, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updatePaymentIn(payload, id) {
  try {
    const response = await api.put(`invoice/paymentIn/` + id, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function payPendingInvoice(payload) {
  try {
    const response = await api.post(`invoice/paymentIn`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteInvoice(id) {
  try {
    const response = await api.delete(`invoice/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deleteMedBill(id) {
  try {
    const response = await api.delete(`medbill/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function deletePaymentIn(id) {
  try {
    const response = await api.delete(`invoice/paymentIn/` + id);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getInvoicePrint(id) {
  try {
    const response = await api.get(`bill/invoice/` + id, {
      responseType: "blob", // Set the responseType to 'blob'
    });
    const file = new Blob([response?.data], {
      type: "application/pdf",
    });
    return { blob: file, response };
  } catch (error) {
    throw error;
  }
}
export async function getMedBillInvoicePrint(id) {
  try {
    const response = await api.get(`bill/med_invoice/` + id, {
      responseType: "blob", // Set the responseType to 'blob'
    });
    const file = new Blob([response?.data], {
      type: "application/pdf",
    });
    return { blob: file, response };
  } catch (error) {
    throw error;
  }
}

export async function getPrescriptionPrint(id) {
  try {
    const response = await api.get(`bill/prescription/` + id, {
      responseType: "blob", // Set the responseType to 'blob'
    });
    const file = new Blob([response?.data], {
      type: "application/pdf",
    });
    return { blob: file, response };
  } catch (error) {
    throw error;
  }
}
